import { Button, Input } from 'antd'
import React, { FC, useState } from 'react'

interface TemplateIdFormProps {
	templateId: string
	updateTemplate(newTemplateId: string): Promise<void>
}

const TemplateIdForm: FC<TemplateIdFormProps> = ({ templateId, updateTemplate }) => {
	const [isSaving, setIsSaving] = useState(false)
	const [formValue, setFormValue] = useState<string>(templateId)

	const handleSubmit = async () => {
		setIsSaving(true)
		await updateTemplate(formValue)
		setIsSaving(false)
	}

	return (
		<div style={{ display: 'flex' }}>
			<Input
				defaultValue={formValue}
				placeholder='0'
				disabled={isSaving}
				onChange={inputElement => setFormValue(inputElement.currentTarget.value)}
				onSubmit={handleSubmit}
				style={{ marginRight: '.5rem' }}
			/>
			<Button loading={isSaving} type='primary' onClick={handleSubmit}>
				{isSaving ? 'Saving' : 'Save'}
			</Button>
		</div>
	)
}

export default TemplateIdForm
